export enum Sort {
  Active = 'ACTIVE',
  Alphabetical = 'ALPHABETICAL',
}
